import React, { useEffect, useState, useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";
import { Endpoints } from "../../repository/Endpoints";
import { GetMaker } from "../../repository/RequestMaker";
import { Translations } from "../../repository/Translations";
import Modal from "react-modal";
import PrivacyStatement from "../privacyStatement/PrivacyStatement";
import Select from 'react-select';
import { Language } from "./Language";
import "./Home.css"; // Importing the custom styles from Home.css

Modal.setAppElement("#root");

const Projects = () => {
  const history = useHistory();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [inMaintainance, setInMaintainance] = useState(false);
  const [projects, setProjects] = useState([]); // State to hold fetched projects
  const [selectedProjectId, setSelectedProjectId] = useState(null); // Track selected project ID
  
  // Set language to German by default if not already set in localStorage
  const language = localStorage.getItem("language") || "de";

  function afterOpenModal() {}

  function closeModal() {
    setIsOpen(false);
  }

  // Handle project selection
  const handleProjectSelect = (option) => {
    setSelectedProjectId(option ? option.value : null);
  };

  // Navigate to the training page of the selected project
  const handleNextClick = () => {
    if (selectedProjectId) {
      localStorage.setItem("selected_project_id", selectedProjectId);
      history.push(`/home/${selectedProjectId}`);
    }
  };

  useEffect(() => {

    localStorage.clear();
    if (!localStorage.getItem("language")) {
      localStorage.setItem("language", "de");
      localStorage.setItem("language_id", "1");
    }
    if (!localStorage.getItem("tenant_id")) {
            // Save Static Tenant ID in the LS for Tennet 
            localStorage.setItem("tenant_id", "719e48fc-5548-4e2e-ba43-a011934b2c89");
    }



    const lastRoute = localStorage.getItem("lastRoute");
    if (lastRoute === "grouptraining") {
      localStorage.setItem("trainingType", "grouptraining");
    }
    window.scrollTo(0, 0);

    // Fetch projects from backend
    const languageId = localStorage.getItem("language_id"); // Set language_id as per requirement
    const tenantId = localStorage.getItem("tenant_id") //"719e48fc-5548-4e2e-ba43-a011934b2c89"; // Set tenant_id as per requirement
    const endpoint = Endpoints.get_project_list(languageId, tenantId);

    GetMaker(endpoint).then((res) => {
      if (res && res.data) {
        const projectOptions = res.data.map((project) => ({
          value: project.id,
          label: project.name,
        }));
        setProjects(projectOptions); // Save projects to state as options
      } else {
        console.error("Failed to fetch projects");
      }
    });
  }, []);

  useLayoutEffect(() => {
    if (!inMaintainance) Translations("de", {});
  }, []);

  return inMaintainance ? (
    <h1>Website im Aufbau. In Kürze wieder verfügbar.</h1>
  ) : (
    <>
      <div className="bg-mine-home">
        <h1 className="text-title-color" id="title_text">
            {Language[language].welcome_message}
        </h1>
        
        <hr className="my-4 text-title-color title_underline" />

        <div className="dropdown-container">
          <Select
            options={projects}
            onChange={handleProjectSelect}
            placeholder="Wählen Sie ein Projekt"
            isSearchable={false}
            styles={{
              option: (base, state) => ({
                ...base,
                color: state.isSelected ? '#073e87' : '#073e87', // Keep the text blue whether selected or not
                backgroundColor: 'transparent', // Remove the background color for selected items
                ':hover': {
                  backgroundColor: '#073e87', // Blue background on hover
                  color: 'white', // White text on hover
                }
              }),
            }}
          />
        </div>

        <br /> <br />

        {selectedProjectId && (
          <div className="button-container">
            <button className="styled-button" onClick={handleNextClick}>
               {Language[language].button_continue}
              &nbsp;
              <i className="fa fa-forward icon-border" aria-hidden="true"></i>
            </button>
          </div>
        )}

        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
            borderRadius: 20,
          }}
        >
          <div className="d-flex justify-content-end">
            <button className="btn-smol" onClick={closeModal}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
          <PrivacyStatement />
        </Modal>
      </div>
      
    </>
  );
};

export default Projects;
